export const cross = require("./icons/close-2.svg") as string
export const marker = require("./icons/marker.svg") as string
export const burger = require("./icons/burger.svg") as string
// export const dots = require("./icons/dots.png") as string
export const dots = require("./icons/dots.svg") as string
export const micro = require("./icons/micro.svg") as string
export const microWhite = require("./icons/micro-white.svg") as string
export const playRound = require("./icons/play-round.svg") as string
export const instagram = require("./icons/instagram.svg") as string
export const twitter = require("./icons/twitter.svg") as string
export const more = require("./icons/more.svg") as string
export const play = require("./icons/play.svg") as string
export const pause = require("./icons/pause.svg") as string
export const mute = require("./icons/mute.svg") as string
export const unmute = require("./icons/unmute.svg") as string
export const download = require("./icons/download.svg") as string
